import { Grid } from "@mui/material";
import { useSelector } from "react-redux";
import { RadioInput } from "../../../../../components/inputs";

const BusinessInterests = () => {
  const isJoint = useSelector((state) => state?.instruction?.isJoint);
  const arr = useSelector((state) => state?.instruction?.arr);

  return (
    <>
      <Grid width={"100%"} display={"flex"} flexDirection={"column"}>
        <Grid
          width={"100%"}
          display={"flex"}
          flexDirection={"row"}
          justifyContent={isJoint ? "space-between" : "center"}
          borderTop={`1px solid #DCDCE1`}
          borderBottom={`1px solid #DCDCE1`}
        >
          {arr?.map((item, index) => {
            return (
              <Grid
                width={isJoint ? "50%" : "62%"}
                borderRight={
                  index === 0 && isJoint ? `1px solid #DCDCE1` : null
                }
                padding={2}
                display={"flex"}
                flexDirection={"column"}
                gap={2}
              >
                <RadioInput
                  label="Are you including power to carry on business?"
                  name={`InstructionWillQuestionnaire.[${index}].businessInterests.carryBusinessPower`}
                  options={[
                    { label: "Yes", value: true },
                    { label: "No", value: false },
                  ]}
                />
              </Grid>
            );
          })}
        </Grid>
      </Grid>
    </>
  );
};

export default BusinessInterests;
